<template>
  <GravManagerWrapper :id="id" :componentName="componentName" :properties="props">
    <component :is="TransactionLog" v-bind="{ style: $attrs.style, ...changableProps }">
      <template v-for="slotName in Object.keys($slots)" #[slotName]="slotProps">
        <slot :name="slotName" v-bind="slotProps" />
      </template>
    </component>
  </GravManagerWrapper>
</template>

<script setup lang="ts">
import GravManagerWrapper from './GravManagerWrapper.vue';
import { TransactionLogProps } from './TransactionLog.ts';
import TransactionLog from './TransactionLog.vue';

import { useChangableProps } from '@/composables/useChangableProps';

const componentName = 'ui-transaction-log';
const $slots = defineSlots<Record<string, unknown>>();

const props = defineProps<TransactionLogProps>();
const changableProps = useChangableProps(componentName, props);

</script>
